var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("bank_accounts.bnk_act_lst") } },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage" },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex form-group justify-content-start showLargeScreenOnly mb-27px",
              },
              [
                _c(
                  "div",
                  { staticClass: "mr-3", attrs: { sm: "2" } },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: {
                          size: "sm",
                          disabled: _vm.$engine.rights.rightIs(
                            "bank_account_ajouter",
                            false
                          ),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.openFormsPage()
                          },
                        },
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.$t("common.add_label")))])]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { attrs: { sm: "2" } },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "mr-3",
                        attrs: { size: "sm" },
                        on: {
                          click: function ($event) {
                            return _vm.openFormListStatement()
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("bank_accounts.view_statements"))
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { attrs: { sm: "2" } },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { size: "sm" },
                        on: {
                          click: function ($event) {
                            return _vm.extractCSV()
                          },
                        },
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.$t("common.extract")))])]
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "layoutSubtitle" }),
            _vm._v(" "),
            _vm.activateSpinner
              ? _c("spinner")
              : _c(
                  "div",
                  [
                    _vm.bankAccounts.length
                      ? _c("b-table", {
                          staticClass: "table-condensed mb-70px",
                          attrs: {
                            hover: "",
                            fixed: "",
                            responsive: "",
                            items: _vm.bankAccounts,
                            fields: _vm.fields,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(isDefault)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-center d-inline-block py-4 w-100 color-var-actionButtonColorBlue",
                                        on: {
                                          click: function ($event) {
                                            return _vm.setDefaultBanqueAccount(
                                              data.item,
                                              $event
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("f7-icon", {
                                          attrs: {
                                            fa:
                                              data.item.isDefault === "1"
                                                ? "star"
                                                : "star-o",
                                            size: "17px",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(edit)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-center d-inline-block py-4 w-100 color-var-actionButtonColorBlue",
                                        on: {
                                          click: function ($event) {
                                            return _vm.modifyBanqueAccount(
                                              data.item,
                                              $event
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("f7-icon", {
                                          attrs: {
                                            fa: "fa-light fa-pencil",
                                            size: "17px",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(delete)",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-center d-inline-block py-4 w-100 color-var-actionButtonColorBlue",
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeBankAccount(
                                              data.item.id,
                                              $event
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("f7-icon", {
                                          attrs: {
                                            fa: "fa-light fa-trash",
                                            size: "17px",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell()",
                                fn: function (data) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "cursor d-inline-block py-4 w-100",
                                        on: {
                                          click: function ($event) {
                                            return _vm.openFormListStatementSingle(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(data.value))]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4062960871
                          ),
                        })
                      : _c(
                          "label",
                          {
                            staticClass:
                              "font-bold w-100 d-flex justify-content-center mt-3",
                          },
                          [_vm._v(_vm._s(_vm.$t("common.no_result")))]
                        ),
                  ],
                  1
                ),
            _vm._v(" "),
            _c(
              "f7-list",
              { staticClass: "searchbar-not-found" },
              [_c("f7-list-item", { attrs: { title: "Nothing found" } })],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "showSmallScreenOnly mt-5" },
          [
            _c(
              "f7-fab",
              {
                staticClass: "leftfav3 button-fab bottomButton",
                attrs: {
                  disabled: _vm.$engine.rights.rightIs(
                    "bank_account_ajouter",
                    false
                  ),
                },
                on: {
                  click: function ($event) {
                    return _vm.openFormsPage()
                  },
                },
              },
              [_c("i", { staticClass: "fa-light fa-grid-2-plus fs-17px" })]
            ),
            _vm._v(" "),
            _c(
              "f7-fab",
              {
                staticClass: "leftfav2 button-fab bottomButton",
                on: {
                  click: function ($event) {
                    return _vm.openFormListStatement()
                  },
                },
              },
              [_c("i", { staticClass: "fa-light fa-euro-sign fs-17px" })]
            ),
            _vm._v(" "),
            _c(
              "f7-fab",
              {
                staticClass: "leftfav button-fab bottomButton",
                on: {
                  click: function ($event) {
                    return _vm.extractCSV()
                  },
                },
              },
              [_c("i", { staticClass: "fa-light fa-file-arrow-down fs-17px" })]
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }